import React from 'react';

const DisclaimerCheckbox = ({
  submitError,
  checked,
  handleOptInChange,
  handleKeyDown,
  disclaimerContent
}) => {
  return (
    <div className="flex gap-x-2">
      <input
        className={`h-3 w-3 rounded ${submitError ? 'border-error' : ''}`}
        type="checkbox"
        id="registration_disclaimer"
        name="opt_in_registeration"
        checked={checked}
        onChange={handleOptInChange}
        onKeyDown={handleKeyDown}
        tabIndex={-1}
      />
      <div className="rte body-4 [&_a]:body-4-bold mb-0 [&_p]:mb-0 text-center" dangerouslySetInnerHTML={{ __html: disclaimerContent }}>
      </div>
    </div>
  );
};

export default DisclaimerCheckbox;
